import passporterLight from './passporter-light.json'
import { ThemeData } from './ThemeCollection'

export default [passporterLight] as ThemeData[]
